import { pathOr } from 'ramda'
import { FILTER_MORE } from '../components/search/constants'
import {
  SNW_FACEBOOK,
  SNW_GOOGLE_PLUS,
  SNW_INSTAGRAM,
  SNW_TWEETER,
} from '../components/secondStep/helpers/drupalSettings'
import dataLayerPush, {pushGA4} from './dataLayerPush';
import {pushBenefitsWidgetHotelPage} from './contentsquare';

const getPageNameGA4 = () => window?.top?.drupalSettings?.g4DataLayerCommonVariables?.pagename;

const pushDL = (data) => {
  const initialData = {
    event: 'GAevent',
  }

  dataLayerPush({ ...initialData, ...data })
}

const titleToUpper = (staticString, toUpperString) => {
  let result = staticString
  if (typeof toUpperString === 'string') {
    result = `${result} - ${toUpperString.toUpperCase()}`
  }
  return result
}

export const pushCustomerReviewsLoadMore = () => {
  pushDL({
    'eventCategory': 'Hotel fact sheet',
    'eventAction': 'Customer reviews - Click on CTA',
    'eventLabel': 'See all reviews'
  })
}

export const pushCustomerReviewsLoadMoreGA4 = (interaction, pagename = getPageNameGA4()) => {
  pushGA4({
    event: 'GA4event',
    eventName: 'block_interact',
    event_data: {
      pagename,
      bloc_name: 'reviews',
      bloc_interaction: interaction,
    }
  }, 'event_data')
}

export const pushClearSearch = () => {
  pushDL({
    eventLabel: 'Clear search',
    eventCategory: 'Search',
    eventAction: 'Search - Click on CTA',
  })
}

export const pushCloseSearch = () => {
  pushDL({
    eventCategory: 'Search',
    eventAction: 'Search - Click on CTA',
    eventLabel: 'Close search',
  })
}

export const pushTopDestinationsClick = (title) => {
  pushDL({
    eventCategory: 'Search',
    eventAction: 'Search - Click on CTA',
    eventLabel: titleToUpper('Our top destinations', title),
  })
}

export const pushSearchAutocomplete = (title) => {
  const dataLayerData = {
    eventCategory: 'Search',
    eventAction: 'Search - Click on CTA',
    eventLabel: titleToUpper('Autocompletion', title),
  }

  pushDL(dataLayerData)
}

export const pushLatestSearchClick = (title) => {
  pushDL({
    eventCategory: 'Search',
    eventAction: 'Search - Click on CTA',
    eventLabel: titleToUpper('Your latest search', title),
  })
}

export const pushSearchClick = (isSearchInHeader = !!window.isSearchInHeader) => {
  pushDL({
    eventAction: `${isSearchInHeader ? 'Header' : 'Search bar'} - Click on CTA`,
  })
}

export const pushSearchNavigationClick = (pagename = getPageNameGA4()) => {
  if (pagename) {
    pushGA4({
      event: 'GA4event',
      eventName: 'booking_form_submit',
      event_data: {
        pagename: pagename,
      }
    }, 'event_data')
  }
}

export const pushSearchSubmitError = ({errorType, errorField}) => {
  if (errorType && errorField) {
    pushGA4({
      event: 'GA4event',
      eventName: 'booking_form_interact',
      event_data: {
        pagename: getPageNameGA4(),
        form_action: 'error',
        error_type: errorType,
        error_field: errorField
      }
    }, 'event_data')
  }
}

export const pushSearchInteract = ({action, field}) => {
  pushGA4({
    event: 'GA4event',
    eventName: 'booking_form_interact',
    event_data: {
      pagename: getPageNameGA4(),
      form_action: action,
      field,
    }
  }, 'event_data')
}

export const pushSearchBarInteract = ({action, label}) => {
  if (action && label) {
    pushGA4({
      event: 'GA4event',
      eventName: 'search_bar_interact',
      event_data: {
        pagename: getPageNameGA4(),
        search_action: action,
        search_label: label
      }
    }, 'event_data')
  }
}

export const pushFiltersOpen = (type) => {
  const dlEventLabel = {
    dates: 'Dates',
    rooms: 'Rooms',
    code: 'Corporate contract code',
    more: 'More filters',
  }

  const eventAction = {
    more: 'Filters - Click on CTA',
  }

  const dataLayerData = {
    eventCategory: 'Search',
    eventAction: eventAction[type] ? eventAction[type] : 'Search - Click on CTA',
    eventLabel: dlEventLabel[type],
  }

  pushDL(dataLayerData)
}

export const pushFiltersClose = (type) => {
  const dlCategory = {
    dates: 'Search',
    rooms: 'Booking funnel - Hotel list',
    code: 'Search',
    more: 'Search',
    sort: 'Search',
  }
  const dlEventLabel = {
    dates: 'Close search panel',
    rooms: 'Close search panel',
    code: 'Close corporate search panel',
    more: 'Close search panel',
    sort: 'Close search panel',
  }

  const dataLayerData = {
    eventCategory: dlCategory[type],
    eventAction: 'Search - Click on CTA',
    eventLabel: dlEventLabel[type],
  }

  pushDL(dataLayerData)
}

export const pushFiltersApply = (type) => {
  const dlEventLabel = {
    dates: 'Apply',
    rooms: 'Apply',
    code: 'See my corporate rates',
    sort: 'Apply',
    more: 'Apply',
  }

  const dataLayerData = {
    eventCategory: 'Search',
    eventAction: 'Search - Click on CTA',
    eventLabel: dlEventLabel[type],
  }

  pushDL(dataLayerData)
}

export const pushDatesSkip = () => {
  const dataLayerData = {
    eventCategory: 'Search',
    eventAction: 'Search - Click on CTA',
    eventLabel: 'Skip dates',
  }
  pushDL(dataLayerData)
}

export const pushOneMoreRoom = () => {
  const dataLayerData = {
    eventCategory: 'Search',
    eventAction: 'Search - Click on CTA',
    eventLabel: 'Show more apartments',
  }
  pushDL(dataLayerData)
}

export const pushShowAllCommentsSearch = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Rates',
    eventAction: 'Hotel info - Click on CTA',
    eventLabel: 'See all reviews',
  }
  pushDL(dataLayerData)
}

export const pushOurApartmentsSearch = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Hotel list',
    eventAction: 'Hotel block - Click on CTA',
    eventLabel: 'Our apartments',
  }
  pushDL(dataLayerData)
}

export const pushLoginLinkSearch = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Rates',
    eventAction: 'User - Click on CTA',
    eventLabel: 'Log in',
  }
  pushDL(dataLayerData)
}

export const pushBookBtnSearch = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Hotel list',
    eventAction: 'Hotel block - Click on CTA',
    eventLabel: 'Book',
  }
  pushDL(dataLayerData)
}

export const pushOpenSortSearch = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Hotel list',
    eventAction: 'Filters - Click on CTA',
    eventLabel: 'Open sort',
  }
  pushDL(dataLayerData)
}

export const pushOpenSortLowSearch = () => {
  const dataLayerData = {
    eventCategory: 'Search',
    eventAction: 'Sort - Click on CTA',
    eventLabel: 'Sort by : Price : Low to High',
  }
  pushDL(dataLayerData)
}

export const pushOpenSortHighSearch = () => {
  const dataLayerData = {
    eventCategory: 'Search',
    eventAction: 'Sort - Click on CTA',
    eventLabel: 'Sort by : Stars : Best to Worst',
  }
  pushDL(dataLayerData)
}

export const pushDotsActionSearch = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Hotel list',
    eventAction: 'Hotel block - Click on CTA',
    eventLabel: 'Browse gallery',
  }
  pushDL(dataLayerData)
}

export const pushFiltersCheckboxes = (args) => {
  const dlEventLabel = {
    price_1: 'Less than 90 EUR',
    price_2: 'Between 90 EUR and 150 EUR',
    price_3: 'More than 150 EUR',
  }

  const dataLayerData = {
    eventCategory: 'Search',
    eventAction: 'Filters - Click on filter',
    eventLabel: dlEventLabel[args],
  }

  pushDL(dataLayerData)
}

export const pushAmenitySeeAll = () => {
  const dataLayerData = {
    eventCategory: 'Search',
    eventAction: 'Filters - Click on CTA',
    eventLabel: 'Facilities - See all',
  }

  pushDL(dataLayerData)
}

export const pushBookMap = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Hotel list',
    eventAction: 'Map - Click on CTA',
    eventLabel: 'Book',
  }

  pushDL(dataLayerData)
}

export const pushMarkerMap = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Hotel list',
    eventAction: 'Map - Click on CTA',
    eventLabel: 'Hotel block',
  }

  pushDL(dataLayerData)
}

export const pushFullMap = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Hotel list',
    eventAction: 'Map - Click on CTA',
    eventLabel: 'Full screen',
  }

  pushDL(dataLayerData)
}

export const pushFullMapGA4 = (pagename = getPageNameGA4()) => {
  pushGA4({
    event: 'GA4event',
    eventName: 'map_open',
    event_data: {
      pagename,
      bloc_name: 'map',
    }
  }, 'event_data')
}

export const mapInteractGA4 = (interaction, pagename = getPageNameGA4()) => {
  pushGA4({
    event: 'GA4event',
    eventName: 'map_interact',
    event_data: {
      pagename,
      map_interaction: interaction,
    }
  }, 'event_data')
}

export const pushSliderLink = (eventLabel, eventLabels) => {
  if (!eventLabel) return
  const { event, eventCategory, eventAction } = eventLabels
  const dataLayerData = {
    event,
    eventCategory,
    eventAction,
    eventLabel,
  }
  pushDL(dataLayerData)
}

export const pushHotelIntroSliderArrow = (side) => {
  const dataLayerData = {
    eventCategory: 'Hotel fact sheet',
    eventAction: 'Infos - Click on CTA',
    eventLabel: `Slide ${side}`,
  }

  pushDL(dataLayerData)
}

export const pushDataLayerSimple = (dataLayerData) => {
  if (dataLayerData) {
    pushDL(dataLayerData)
  }
}

export const pushHotelCardInteract = (interaction) => {
  if (interaction) {
    pushGA4({
      event: 'GA4event',
      eventName: 'bloc_interact',
      event_data: {
        pagename: getPageNameGA4(),
        bloc_name: 'hotel',
        bloc_interaction: interaction,
      }
    }, 'event_data')
  }
}

export const pushRateCardInteract = (interaction) => {
  if (interaction) {
    pushGA4({
      event: 'GA4event',
      eventName: 'bloc_interact',
      event_data: {
        pagename: getPageNameGA4(),
        bloc_name: 'rate',
        bloc_interaction: interaction,
      }
    }, 'event_data')
  }
}

export const pushCardOptionsInteract = ({action, type, quantity}) => {
  pushGA4({
    event: 'GA4event',
    eventName: 'options_interact',
    event_data: {
      pagename: getPageNameGA4(),
      option_action: action,
      option_type: type,
      option_quantity: quantity
    }
  }, 'event_data')
}

export const pushDestinationMapMarker = () => {
  const dataLayerData = {
    eventCategory: 'Destinations',
    eventAction: 'Map search - Click on CTA',
    eventLabel: 'Expand zone',
  }

  pushDL(dataLayerData)
}

export const pushDestinationMapLinks = () => {
  const dataLayerData = {
    eventCategory: 'Destinations',
    eventAction: 'Map search - Click on CTA',
    eventLabel: 'Hotel block',
  }

  pushDL(dataLayerData)
}

export const pushGoToPayment = () => {
  const dataLayerData = {
    eventCategory: 'booking funnel step 2 - information',
    eventAction: 'funnel - continue',
    eventLabel: 'go to payment',
  }

  pushDL(dataLayerData)
}

export const pushDetailsInfoItems = (type) => {
  if (typeof type !== 'undefined' && typeof type !== 'null') {
    const dataLayerData = {
      eventCategory: 'Booking funnel step 2 - information',
      eventAction: 'Options - Click on CTA',
      eventLabel: `Add option ${type}`,
    }

    pushDL(dataLayerData)
  }
}

export const pushCallMeBack = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel step 2 - information',
    eventAction: 'Assistance - Click on CTA',
    eventLabel: 'Call me back',
  }

  pushDL(dataLayerData)
}

export const pushHeaderSearchEditable = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Rates',
    eventAction: 'Rates - Click on CTA',
    eventLabel: 'Edit',
  }

  pushDL(dataLayerData)
}

export const pushSeeConditionLink = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Rates',
    eventAction: 'Rates - Click on CTA',
    eventLabel: 'Read rate conditions',
  }

  pushDL(dataLayerData)
}

export const pushBasketHotelCardUsersVote = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Rates',
    eventAction: 'Hotel info - Click on CTA',
    eventLabel: 'See all reviews',
  }

  pushDL(dataLayerData)
}

export const pushBasketHotelCardSeeOnMap = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Rates',
    eventAction: 'Hotel info - Click on CTA',
    eventLabel: 'See the map',
  }

  pushDL(dataLayerData)
}

export const pushBasketPaymentDetails = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Rates',
    eventAction: 'Rates - Click on CTA',
    eventLabel: 'Payment details',
  }

  pushDL(dataLayerData)
}

export const pushBasketConfirmationButton = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Rates',
    eventAction: 'Rates - Click on CTA',
    eventLabel: 'Book',
  }

  pushDL(dataLayerData)
}

export const pushBasketDetails = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Rates',
    eventAction: 'Rates - Click on CTA',
    eventLabel: 'See details',
  }

  pushDL(dataLayerData)
}

export const pushOffersOptions = (optionId) => {
  const dataLayerData = {
    eventCategory: 'Booking funnel step 1 - apartment and options',
    eventAction: 'Options - Click on CTA',
    eventLabel: `Add option ${optionId.toUpperCase()}`,
  }

  pushDL(dataLayerData)
}

export const pushYourDetailsBlockEditPersonalInfo = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Payment',
    eventAction: 'Existing client - Click on CTA',
    eventLabel: 'Edit my personal information',
  }

  pushDL(dataLayerData)
}

export const pushYourDetailsBlockReasonRadio = (reason) => {
  const eventLabel = {
    PERSONAL: 'Personal',
    BUSINESS: 'Professional',
  }

  if (eventLabel[reason]) {
    const dataLayerData = {
      eventCategory: 'booking funnel step 2 - information',
      eventAction: 'Profile - Purpose of your stay',
      eventLabel: eventLabel[reason],
    }

    pushDL(dataLayerData)
  }
}

export const pushYourDetailsBlockSassMailAgreement = (status) => {
  if (status) {
    const dataLayerData = {
      eventCategory: 'Booking funnel - Payment',
      eventAction: 'Terms and conditions - Click on CTA',
      eventLabel: 'Newsletter subscription',
    }

    pushDL(dataLayerData)
  }
}

export const pushPromoCodeApply = (code) => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Payment',
    eventAction: 'Checkout - Click on CTA',
    eventLabel: `Apply promo code - ${code}`,
  }

  pushDL(dataLayerData)
}

export const pushSearchOpen = () => {
  const dataLayerData = {
    eventCategory: 'Navigation',
    eventAction: 'Header - Click on CTA',
    eventLabel: 'Search',
  }

  pushDL(dataLayerData)
}

export const pushSearchClear = (type) => {
  if (type === FILTER_MORE) {
    const dataLayerData = {
      eventCategory: 'Search',
      eventAction: 'Search - Click on CTA',
      eventLabel: 'Clear filters',
    }

    pushDL(dataLayerData)
  }
}

export const pushSearchOfferHeader = (titleEn) => {
  const dataLayerData = {
    eventCategory: 'Search - Participating aparthotels',
    eventAction: 'Search - Click on CTA',
    eventLabel: titleToUpper('City', titleEn),
  }

  pushDL(dataLayerData)
}

export const pushSearchOfferBody = (hotelCode) => {
  const dataLayerData = {
    eventCategory: 'Search - Participating aparthotels',
    eventAction: 'Search - Click on CTA',
    eventLabel: `Aparthotels - ${hotelCode}`,
  }

  pushDL(dataLayerData)
}

export const pushSecondStepLoggedInLink = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Payment',
    eventAction: 'Existing client - Click on CTA',
    eventLabel: 'Access my account',
  }

  pushDL(dataLayerData)
}

export const pushConnectEvent = (type) => {
  pushDL({
    eventCategory: 'Booking funnel - Checkout',
    eventAction: 'Checkout - Click on CTA',
    eventLabel: type,
  })
}

export const pushTopLevelMenuItemClick = ({pagename, type, index}) => {
  pushGA4({
    event: 'GA4event',
    eventName: 'menu_interact',
    event_data: {
      pagename: pagename,
      menu_position: index,
      menu_label: type,
    }
  }, 'event_data')
}

export const pushSecondStepSocialLinks = (type) => {
  switch (type) {
    case SNW_FACEBOOK:
      type = 'Facebook'
      break
    case SNW_GOOGLE_PLUS:
      type = 'Google+'
      break
    case SNW_TWEETER:
      type = 'Twitter'
      break
    case SNW_INSTAGRAM:
      type = 'Instagram'
      break
    default:
      type = null
  }
  if (type) {
    const dataLayerData = {
      eventCategory: 'booking funnel step 2 - information',
      eventAction: 'Existing client - Click on CTA',
      eventLabel: `${type}`,
    }

    pushDL(dataLayerData)
  }
}
const pushDLEvent = (data) => {
  const initialData = {
    event: 'GAvirtual',
  }

  if (window.dataLayer.hasOwnProperty('push')) {
    const pushFn = pathOr((d) => {
      console.info('%c data layer push:', 'color: #c20019; font-weight: bold;', d)
    }, ['dataLayer', 'push'], window)
    pushFn({ ...initialData, ...data })
  } else {
    window.dataLayer.push({ ...initialData, ...data })
    console.log('dataLayer missing property push')
  }
}

export const pushErrorOpenPopup = () => {
  const pushErrorPopup = {
    virtualpageview: '/booking/payment/new-client-warning',
  }

  pushDLEvent(pushErrorPopup)
}

export const pushErrorClosePopup = () => {
  const dataLayerData = {
    eventCategory: 'Booking funnel - Payment',
    eventAction: 'Checkout - Click on CTA',
    eventLabel: 'New client pop-in - Agree',
  }

  pushDL(dataLayerData)
}

export const pushCheckoutBreadcrumbs = () => {
  const dataLayerData = {
    eventCategory: 'booking funnel step 2 - information',
    eventAction: 'breadcrumb - click on cta',
    eventLabel: 'back to apartments and options',
  }

  pushDL(dataLayerData)
}

export const pushCheckoutCreateFreeAccount = () => {
  const dataLayerData = {
    eventCategory: 'booking funnel step 2 - information',
    eventAction: 'Checkout - Click on CTA',
    eventLabel: 'New client pop-in Agree',
  }

  pushDL(dataLayerData)
}

export const pushCheckoutEmailField = () => {
  const dataLayerData = {
    eventCategory: 'booking funnel step 2 - information',
    eventAction: 'checkout - click on cta',
    eventLabel: 'continue as a guest',
  }

  pushDL(dataLayerData)
}

export const pushCheckoutAddOption = (optionName) => {
  pushDL({
    eventCategory: 'Booking funnel - Checkout',
    eventAction: 'Options - Click on CTA',
    eventLabel: `Add option - ${optionName}`,
  })
}

export const checkoutVersionEvent = (eventAction = 0, pageName = getPageNameGA4()) => {
  pushGA4({
    event: 'GA4event',
    eventName: 'ab_test_new_design_checkout',
    event_data: {
      variation_id: eventAction,
      pagename: pageName,
    }
  }, 'event_data')
}

export const priceTaxesVersionEvent = (variation = 'control', pageName = getPageNameGA4()) => {
  pushGA4({
    event: 'GA4event',
    eventName: 'campaign_ab_test',
    event_data: {
      variation_id: `Rates - Taxes incluses - ${variation}`,
      pagename: pageName,
    }
  }, 'event_data')
}

export const homeMobileSearchVersionEvent = (variation = 0, pageName = getPageNameGA4()) => {
  pushGA4({
    event: 'GA4event',
    eventName: 'campaign_ab_test',
    event_data: {
      variation_id: `ab_test_new_mobile_search_${variation}`,
      pagename: pageName,
    }
  }, 'event_data')
}

export const pushMenuOpen = (pageName) => {
  if (pageName) {
    pushGA4({
      event: 'GA4event',
      eventName: 'menu_open',
      event_data: {
        pagename: pageName,
      }
    }, 'event_data')
  }
}

export const pushBenefits = (variation, pageName = getPageNameGA4()) => {
  if (variation) {
    pushGA4({
      event: 'GA4event',
      eventName: 'campaign_ab_test',
      event_data: {
        pagename: pageName,
        variation_id: `Hotel Page - benefits wrapper - ${variation}`,
      },
    }, 'event_data')
  }
}

export const pushEcommerceInfo = (data) => {
  if (data) {
    pushGA4({
      event: data.event,
      ecommerce: data.ecommerce,
    }, 'ecommerce')
  }
}

export const pushCheckoutInteractAction = (data) => {
  if (data) {
    pushGA4({
      event: 'GA4event',
      eventName: 'bloc_interact',
      event_data: {
        pagename: getPageNameGA4(),
        ...data
      },
    }, 'event_data')
  }
}

export const pushCreateAccountAction = (ctaName, pagename = getPageNameGA4()) => {
  if (ctaName) {
    pushGA4({
      event: 'GA4event',
      eventName: 'cta_enroll',
      event_data: {
        pagename,
        cta_name: ctaName,
        enroll_context: 'adagio'
      }
    }, 'event_data')
  }
}

export const pushLoginAction = (ctaName, pagename = getPageNameGA4()) => {
  if (ctaName) {
    pushGA4({
      event: 'GA4event',
      eventName: 'cta_authentication',
      event_data: {
        pagename,
        cta_name: ctaName,
      }
    }, 'event_data')
  }
}

export const pushBasketInteractAction = (ctaName, pagename = getPageNameGA4()) => {
  if (ctaName) {
    pushGA4({
      event: 'GA4event',
      eventName: 'basket_information',
      event_data: {
        pagename,
        cta_name: ctaName,
      }
    }, 'event_data')
  }
}

export const pushBasketSubmitAction = (type, data) => {
  if (data) {
    pushGA4({
      event: 'GA4event',
      eventName: type,
      event_data: {
        pagename: getPageNameGA4(),
        ...data
      }
    }, 'event_data')
  }
}

export const pushFunnelStepInfo = (stepName, error, pagename = getPageNameGA4()) => {
  if (stepName) {
    pushGA4({
      event: 'GA4event',
      eventName: 'funnel_step',
      event_data: {
        pagename,
        step_name: stepName,
        ...(error ? {error_type: error} : {})
      }
    }, 'event_data')
  }
}

export const pushFunnelStartInfo = (stepName, error, pagename = getPageNameGA4()) => {
  if (stepName) {
    pushGA4({
      event: 'GA4event',
      eventName: 'funnel_start',
      event_data: {
        pagename,
        step_name: error ? stepName + '::error' : stepName,
        ...(error ? {error_type: error} : {})
      }
    }, 'event_data')
  }
}

export const pushDestinationTestSearch = (variation = 0, pagename = getPageNameGA4()) => {
  if (pagename) {
    pushGA4({
      event: 'GA4event',
      eventName: 'ab_test_destination_with_search',
      event_data: {
        pagename,
        variation_id: variation
      }
    }, 'event_data')
  }
}
